import React, { useContext, useState } from 'react'
import PrimaryButton from 'components/generic/PrimaryButton'
import { trackClickEvent } from 'utils/Analytics'
import { USER_TYPES } from 'components/GetStarted/constants'
import { StepHeading, ButtonOption, ContentContainer } from 'components/GetStarted/styles'
import { AppContext } from 'contexts/AppContext'

const StepUserType = ({ data, onStepComplete, userInput }) => {
  const { domain } = useContext(AppContext)
  const [userType, setUserType] = useState(userInput?.user_type)
  const onSelectUserType = (type) => setUserType(type)
  const onNextClick = () => {
    trackClickEvent(domain, 'get-started-next-user-type')
    onStepComplete({
      user_type: userType,
    })
  }
  return (
    <ContentContainer>
      <StepHeading>What are you looking for?</StepHeading>
      <ButtonOption
        selected={userType === USER_TYPES.PROVIDER}
        onClick={() => onSelectUserType(USER_TYPES.PROVIDER)}
      >
        I am looking for {data?.site?.suffixed_job_name}
      </ButtonOption>
      <ButtonOption
        selected={userType === USER_TYPES.SEEKER}
        onClick={() => onSelectUserType(USER_TYPES.SEEKER)}
      >
        I am looking for {data?.site?.plural_provider_name}
      </ButtonOption>
      <PrimaryButton mt='2rem' disabled={!userType} onClick={onNextClick}>
        Next
      </PrimaryButton>
    </ContentContainer>
  )
}

export default StepUserType
